import { PlayersApp } from '@datapad/players';
import { assertNotUndefined } from '@datapad/utilities';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { DatapadAppStateContext } from '../../../utilities';
import { AppId } from '../AppId';

/**
 * Players app wrapper.
 *
 * @remarks
 * Handles URL parameter management for player selection.
 * URL format: `/players?id=<player-id>`
 * Players are retrieved via {@link AppContext.getAllUsers}.
 * GM-only access control is handled by the PlayersApp component itself.
 */
export function Players(): React.ReactElement {
	const location = useLocation();

	const { changeAppSelection } = assertNotUndefined(React.useContext(DatapadAppStateContext));

	// Parse URL for selection
	const searchParams = new URLSearchParams(location.search);
	const selectedId = searchParams.get('id') ?? undefined;

	// Handle selection changes by updating URL
	const handleSelectionChange = React.useCallback(
		(playerId: string | undefined) => {
			const search = playerId ? `id=${playerId}` : '';
			changeAppSelection(AppId.Players, search, undefined);
		},
		[changeAppSelection],
	);

	return <PlayersApp selection={selectedId} changeSelection={handleSelectionChange} />;
}
